"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProgramHero = _interopRequireDefault(require("../components/ProgramHero/ProgramHero"));

var _KeyBenefits = _interopRequireDefault(require("../components/KeyBenefits/KeyBenefits"));

var _ContactInfo = _interopRequireDefault(require("../components/ContactInfo/ContactInfo"));

var _BenefitsList = _interopRequireDefault(require("../components/BenefitsList/BenefitsList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var BasicTemplate = function BasicTemplateComponent(_ref) {
  var dataClient = _ref.dataClient,
      pageData = _ref.pageData;
  var key_benefits = pageData.key_benefits,
      contact_list = pageData.contact_list,
      contact_section_title = pageData.contact_section_title,
      benefits_list = pageData.benefits_list;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ProgramHero["default"], {
    dataClient: dataClient,
    pageData: pageData
  }), key_benefits.length > 0 && /*#__PURE__*/_react["default"].createElement(_KeyBenefits["default"], {
    dataClient: dataClient,
    pageData: pageData
  }), benefits_list.length > 0 && /*#__PURE__*/_react["default"].createElement(_BenefitsList["default"], {
    dataClient: dataClient,
    pageData: pageData
  }), contact_list && /*#__PURE__*/_react["default"].createElement(_ContactInfo["default"], {
    contactList: contact_list,
    sectionTitle: contact_section_title,
    dataClient: dataClient
  }));
};

BasicTemplate.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  pageData: _propTypes["default"].shape({}).isRequired
};
var _default = BasicTemplate;
exports["default"] = _default;